export default ({
  className,
  dodoableId,
  onNav,
  text = 'Dodoable Dodones'
}) => {
  return (
    <Link className={className} to={`/dodoables/${dodoableId}`} onClick={onNav}>
      {text}
    </Link>
  )
}
